// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"a47ed4c1","453":"a5b25d5b","796":"a2244b3f"}[chunkId] + ".chunk.js";
};